import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type ViewRowType = {
  title: string;
  content: string;
};

const MailViewRow: React.FC<ViewRowType> = (props) => {
  return (
    <TableRow
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        '&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body': {
          py: '16px',
          borderBottom: '1px solid #F3F3F3',
        },
      }}
    >
      <TableCell component={'th'} sx={{minWidth: '150px'}}>{props.title}</TableCell>
      <TableCell sx={{whiteSpace: 'pre-line'}}>{props.content}</TableCell>
    </TableRow>
  );
};

export default MailViewRow;
